import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { CSSProperties, ReactNode, useEffect, useState } from 'react';
import { usePrevious } from 'react-use';
import styled, { keyframes } from 'styled-components';

import { IconButton } from 'atoms/buttons/IconButton';
import { Horizontal } from 'atoms/layout/flex';
import { Color } from 'style/types';
import { regularMaterial } from 'style/utils';

const borderBlink = keyframes`
0% {
  border-color: var(--c-nd-150);
}
50% {
  border-color: var(--border-color);
}
100% {
  border-color: var(--c-nd-150);
}`;
const Wrapper = styled(Horizontal)`
  min-width: min(100%, 500px);
  padding: var(--intermediate-unit) var(--double-unit);
  border: 1px solid var(--c-nd-150);
  border-radius: var(--double-unit);
  align-items: center;
  justify-content: space-between;

  ${regularMaterial}

  &.add, &.drop {
    animation: ${borderBlink} 0.7s;
  }
  &.add {
    --border-color: var(--color);
  }
  &.drop {
    --border-color: var(--c-nd-400);
  }
`;

type Props = {
  nbCardsSelected: number;
  color: Color;
  onCancel: () => void;
  children: ReactNode;
  button: ReactNode;
};

export const SelectionSummary = ({
  nbCardsSelected,
  color,
  button,
  children,
  onCancel,
}: Props) => {
  const previousNbCardsSelected = usePrevious(nbCardsSelected);
  const [animation, setAnimation] = useState<'add' | 'drop' | null>(null);

  useEffect(() => {
    if (previousNbCardsSelected !== nbCardsSelected) {
      if ((previousNbCardsSelected || 0) < nbCardsSelected) {
        setAnimation('add');
      } else if ((previousNbCardsSelected || 0) > nbCardsSelected) {
        setAnimation('drop');
      }
    }
    setTimeout(() => setAnimation(null), 700);
  }, [nbCardsSelected, previousNbCardsSelected]);

  return (
    <Wrapper
      style={{ '--color': color } as CSSProperties}
      className={classNames(animation)}
    >
      {children}
      <Horizontal>
        {button}
        <IconButton onClick={onCancel} icon={faTimes} color="red" />
      </Horizontal>
    </Wrapper>
  );
};
